// When a page was sent, for the places that show it. A time alone ("11:12 PM")
// reads as today, so anything older carries its day — otherwise yesterday's
// 11:12 PM sorts below today's 11:06 PM and looks out of order.
import { formatTime, formatStamp } from '../pm/format.js';

const sameDay = (a, b) => a.toDateString() === b.toDateString();
/** "24 SEP" — the day part of formatStamp. */
const dayOf = (ts) => formatStamp(ts).split(' ').slice(0, 2).join(' ');

/** LCD columns: "11:06 PM" today, "23 SEP" before. */
export function whenShort(ts, now = new Date()) {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  return sameDay(d, now) ? formatTime(ts) : dayOf(ts);
}

/** Thread meta: "11:06 PM" today, "23 SEP 9:10 PM" before — one clock, 12-hour. */
export function whenLong(ts, now = new Date()) {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '';
  return sameDay(d, now) ? formatTime(ts) : `${dayOf(ts)} ${formatTime(ts)}`;
}
